export default __webpack_public_path__ + "static/media/spectra-com11.6a252e3a.jpg";